/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

//Scroll Listener for page header animation class add/remove
$(document).ready(function () {
    setInterval(function () {
        if ($(window).scrollTop() > 0) {
            $('body').addClass('page-scrolled');
        } else {
            $('body').removeClass('page-scrolled');
        }
    }, 50);
    //Click listener to show/hide main nav subnavs
    $('.has-dropdown > a, .menu-item-has-children > a').click(function (e) {
        if ($(document).width() < 890) {
            e.preventDefault();
            var parent = $(this).parent();
            $('.dropdown-active').not(parent).removeClass('dropdown-active').children('.sub-menu').slideUp(200);
            parent.toggleClass('dropdown-active');
            $(this).next().slideToggle(200);
        }
    });
    //Main Nav click listener
    $('[data-toggle="navigation"]').click(function(e) {
        e.preventDefault();
        $('body').toggleClass('nav-expanded');
        $('.dropdown-active').removeClass('dropdown-active').children('.sub-menu').slideUp(200);
    });
    //top nav click listener
    $('[data-toggle="topnav"]').click(function (e) {
        $('body').toggleClass('topnav-expanded');
    });
});
